
<div class="feed">
  <ftu-block
    dismiss-key="feed"
    icon="rss_feed"
    title="This is the Feed"
    description="The Feed is a curated content hub of sports card collecting content. We include content from some of best content creators in the hobby, with hand-picked podcasts, videos, articles, and headlines that we believe are worthy of consuming. You'll also find helpful updates from and about Card Ladder here."
  />

  <page-header title="Feed">
    <template #actions>
      <icon-button
        v-if="isStaff"
        icon="add_circle"
        @click="addPost"
      />
    </template>
  </page-header>

  <align class="header" flex direction="flex-start">
    <div>
      <search-area
        v-model="query"
        class="input"
      />
    </div>

    <pill-dropdown
      v-model="filter"
      :options="filterOptions"
    />
  </align>

  <div class="results">
    <empty-state
      v-if="showEmptyState"
      icon="search_off"
      title="There are no results for your query"
      description="Try searching for something else"
    />

    <template>
      <div class="list">
        <post-item
          v-for="(post, i) in posts"
          :key="post.id"
          :post="post"
          :rank="i + 1"
          :is-admin="isAdmin"
          @deletePost="deletePost"
        />
      </div>

      <infinite-scroll
        :loading="loading"
        :has-more-data="hasMoreData"
        @load="nextPage"
      />
    </template>
  </div>

  <scroll-top />
</div>
